export default __webpack_public_path__ + "static/media/sound_silentnight.bf960e00.wav";